<template>
    <div class="accordion">
        <template v-for="(item, i) in localList">
            <dl class="border-t border-t-neutral-500 first:border-t-0" :id="slugify(item.term)">
                <div class="py-3 first:pt-0 last:pb-0">
                    <dt class="py-3">
                        <div class="relative">
                            <button v-if="item.expanded"
                                    class="absolute -left-8 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-white transition-colors"
                                    @click.stop="copyLink(slugify(item.term))"
                                    title="Copy link to this section">
                                <i class="fa-fw fa-light fa-sharp fa-link"></i>
                            </button>
                            <button type="button"
                                    class="flex w-full items-start justify-between text-left text-white"
                                    :aria-controls="`item-${i}`"
                                    :aria-expanded="item.expanded"
                                    @click="handleToggle(i)"
                            >
                                <h3 class="text-base/7 font-semibold">
                                    {{ item.term }}
                                </h3>
                                <span class="ml-6 flex h-7 items-center">
                                    <i class="fa-fw fa-light fa-sharp fa-plus" v-if="!item.expanded"/>
                                    <i class="fa-fw fa-light fa-sharp fa-minus" v-else/>
                                </span>
                            </button>
                        </div>
                    </dt>
                    <dd class="pb-4" :class="[!item.expanded ? 'hidden' : null]" :id="`item-${i}`"
                        v-html="item.description"></dd>
                </div>
            </dl>
        </template>
    </div>
</template>

<script>
import slugify from 'slugify';

export default {
    name: 'Accordion',
    created() {
        this.localList = [
            ...this.list,
        ];
    },
    mounted() {
        this.handleHashChange();
        window.addEventListener('hashchange', this.handleHashChange);
    },
    beforeDestroy() {
        window.removeEventListener('hashchange', this.handleHashChange);
    },
    data() {
        return {
            localList: [],
        };
    },
    methods: {
        handleHashChange() {
            const hash = window.location.hash.substring(1); // Remove the # symbol
            if (!hash) return;

            const index = this.localList.findIndex(item => this.slugify(item.term) === hash);
            if (index !== -1) {
                this.handleToggle(index);
            }
        },
        handleToggle(i) {
            this.localList = [
                ...this.localList.map((item, j) => {
                    if (i === j) {
                        item.expanded = !item.expanded;
                    } else {
                        item.expanded = false;
                    }

                    return item;
                }),
            ];
        },
        async copyLink(hash) {
            const url = `${window.location.origin}${window.location.pathname}#${hash}`;
            try {
                await navigator.clipboard.writeText(url);
                window.app.snackbar({ message: 'Link copied to clipboard', type: 'success' });
            } catch (err) {
                console.error('Failed to copy URL:', err);
                window.app.snackbar({ message: 'Failed to copy link', type: 'error' });
            }
        },
        slugify(string) {
            return slugify(string.toLowerCase());
        },
    },
    props: {
        list: {
            required: true,
            type: Array,
        },
    },
};
</script>

<style scoped lang="scss">

</style>
